import Button from './Button'

export interface ButtonProps {
	size?: string
	color?: string
}

export default Button
